// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Si-z","carouselContainer":"Ti-z","carouselContent":"Ui-z"};